import script from "./TermPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermPage.vue?vue&type=script&setup=true&lang=js"

import "./TermPage.vue?vue&type=style&index=0&id=576c9ba2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-576c9ba2"]])

export default __exports__